import { NavigateOptions, useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { EntityType } from 'app/agriculture/models/Entities';
import { routeConfig } from 'app/agriculture/router/routeConfig';
import { useFarmPath } from 'app/agriculture/router/useFarmPath';

export function useRouteActions() {
    const navigate = useNavigate();
    const farmPath = useFarmPath();

    const edit = useCallback(
        (
            id: string | number,
            { type, ...navigateOptions }: { type: EntityType } & NavigateOptions,
        ) => {
            navigate(
                farmPath(`/${routeConfig[type].rootPath}/${id.toString()}/edit`),
                navigateOptions,
            );
        },
        [farmPath, navigate],
    );

    const goto = useCallback(
        (
            id: string | number,
            { type, ...navigateOptions }: { type: EntityType } & NavigateOptions,
        ) => {
            navigate(farmPath(`/${routeConfig[type].rootPath}/${id.toString()}`), navigateOptions);
        },
        [farmPath, navigate],
    );

    const remove = useCallback(
        (
            id: string | number,
            { type, ...navigateOptions }: { type: EntityType } & NavigateOptions,
        ) => {
            navigate(
                farmPath(`/${routeConfig[type].rootPath}/${id.toString()}/delete`),
                navigateOptions,
            );
        },
        [farmPath, navigate],
    );

    interface CreateActionOptions {
        parentId?: string | number;
    }

    const create = useCallback(
        (type: EntityType, { parentId }: CreateActionOptions = {}) => {
            navigate(farmPath(`/${routeConfig[type].rootPath}/create`), {
                state: { parentId },
            });
        },
        [farmPath, navigate],
    );

    const openList = useCallback(
        (type: EntityType) => {
            navigate(farmPath(`/${routeConfig[type].rootPath}`));
        },
        [farmPath, navigate],
    );

    return { create, edit, goto, remove, openList };
}
